import { render, staticRenderFns } from "./WidgetPageStepsLayout.vue?vue&type=template&id=1a4052bc&scoped=true&"
import script from "./WidgetPageStepsLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetPageStepsLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPageStepsLayout.vue?vue&type=style&index=0&id=1a4052bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4052bc",
  null
  
)

export default component.exports